module.exports = __webpack_public_path__ + "img/0777a1ecf579df87368158b9be38ca78.png";